import React from "react";
import {withStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";

import Select from './Select';
import TextField from './TextField';
import {getRegionsByCountryCode} from "../constants/Regions";
import {CountryCodes} from '../constants/Countries';
import {FormattedMessage, useIntl} from "react-intl";

const styles = (theme) => ({

});

RegionInput.propTypes = {
  countryCode: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  children: PropTypes.object,
  error: PropTypes.object,
  fullWidth: PropTypes.bool,
};

function RegionInput({countryCode, id, label, value, onChange, classes, children, fullWidth, error}, props) {

    const intl = useIntl();
    const showRegionSelect = countryCode === CountryCodes.US || countryCode === CountryCodes.CA;
    let regions = getRegionsByCountryCode(countryCode);

    let labelId = 'label.region';
    let emptyOptionLabelId = 'label.select-region';
    if(countryCode === CountryCodes.US) {
      labelId = 'label.state';
      emptyOptionLabelId = 'label.select-state';
    } else if(countryCode === CountryCodes.CA) {
      labelId = 'label.province';
      emptyOptionLabelId = 'label.select-province';
    }

    if (showRegionSelect) {
      return (
        <Select
          id={id}
          label={<FormattedMessage id={labelId}/>}
          placeholder={intl.formatMessage({id: labelId})}
          onChange={onChange}
          value={value}
          error={error}
          fullWidth={fullWidth}
          autofill={'address-level1'}
          >
          <option disabled="true" selected={!value} value="">{intl.formatMessage({id: emptyOptionLabelId})}</option>
          {Object.keys(regions).map((regionCode) => <option value={regionCode}>{regions[regionCode]}</option>)}
        </Select>
      );
    }

    return (
      <TextField
        id={id}
        label={<FormattedMessage id={labelId}/>}
        onChange={onChange}
        variant={'outlined'}
        value={value}
        error={error}

        {...props}
      />
    );
}

export default withStyles(styles)(RegionInput);
